import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  if (location.pathname === '/login') return null;

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const navItems = [
    { label: 'الرئيسية', icon: '🏠', path: '/' },
    { label: 'المحلات', icon: '🏪', path: '/stores' },
    { label: 'العمليات', icon: '🧾', path: '/transactions' },
    { label: 'التقارير', icon: '📊', path: '/reports' },
    { label: 'المزيد', icon: '⋯', path: '__more' }
  ];

  const quickActions = [
    { label: 'شحن محل', hint: 'إضافة شحن جديد', icon: '⚡', path: '/transactions?quick=recharge' },
    { label: 'قبض من محل', hint: 'تسجيل قبض', icon: '💵', path: '/transactions?quick=collection' },
    { label: 'مصروف', hint: 'تسجيل مصروف', icon: '💸', path: '/transactions?quick=expense' },
    { label: 'تسديد شركة', hint: 'تسديد من محفظة', icon: '🏢', path: '/transactions?quick=settlement' },
    { label: 'إضافة رصيد', hint: 'زيادة رصيد مستخدم', icon: '💳', path: '/user-balance' },
    { label: 'تحويل رصيد', hint: 'بين المستخدمين', icon: '🔁', path: '/user-balance' },
    { label: 'نقل دين', hint: 'بين المحلات', icon: '🔀', path: '/store-debt-transfer' }
  ];

  const morePages = [
    { label: 'رصيدي', icon: '💼', path: '/user-balance' },
    { label: 'نقل دين', icon: '🔀', path: '/store-debt-transfer' },
    { label: 'المحافظ', icon: '👛', path: '/wallets' },
    { label: 'الإشعارات', icon: '🔔', path: '/notifications' },
    { label: 'الموظفين', icon: '👥', path: '/employees' },
    { label: 'الإعدادات', icon: '⚙️', path: '/settings' },
    { label: 'الأرشيف', icon: '🗂️', path: '/archive' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {open && <button className="mobile-nav-backdrop" type="button" aria-label="إغلاق القائمة" onClick={() => setOpen(false)} />}

      {open && (
        <div className="mobile-quick-sheet" dir="rtl">
          <div className="mobile-quick-sheet-handle" />
          <div className="mobile-quick-sheet-header">
            <div>
              <h3>إضافة ووصول سريع</h3>
              <p>اختار العملية أو الصفحة المطلوبة بسرعة</p>
            </div>
            <button type="button" onClick={() => setOpen(false)} aria-label="إغلاق">×</button>
          </div>

          <div className="mobile-quick-grid">
            {quickActions.map((item) => (
              <button key={item.label} type="button" onClick={() => go(item.path)}>
                <span>{item.icon}</span>
                <strong>{item.label}</strong>
                <small>{item.hint}</small>
              </button>
            ))}
          </div>

          <div className="mobile-more-pages">
            {morePages.map((item) => (
              <button key={item.path} type="button" onClick={() => go(item.path)}>
                <span>{item.icon}</span>
                <b>{item.label}</b>
              </button>
            ))}
          </div>
        </div>
      )}

      <nav className="mobile-bottom-nav" dir="rtl" aria-label="التنقل السريع للهاتف">
        {navItems.map((item) => {
          const more = item.path === '__more';
          return (
            <button
              key={item.label}
              type="button"
              className={`${more ? 'mobile-bottom-more' : ''} ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => more ? setOpen(value => !value) : go(item.path)}
            >
              <span className="mobile-nav-icon">{item.icon}</span>
              <span className="mobile-nav-label">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
}

export default MobileBottomNav;
